module.exports = {
  "country": "DE",
  "artist": "Cascada",
  "song": "Glorious",
  "year": "2013",
  "place": "21",
  "spotify": "1UqzLT0ZGWXD9K5npit5Nr"
};